/**
 * Rascunho automático (p.16): "Formulário com mais de dez campos salva
 * rascunho automático. Conexão em obra cai, e o preenchimento não pode se
 * perder."
 *
 * Vale para o apontamento de turno (onze campos) e para a conferência da folha
 * de turno (uma grade inteira de linhas corrigidas à mão).
 *
 * Fica no `localStorage` DESTE navegador, com o usuário na chave: quem divide
 * o computador do escritório da obra não abre o turno pela metade de outro.
 * Não é dado do sistema — o que vale continua sendo o que o servidor gravou;
 * isto só devolve a digitação a quem a fez.
 *
 * Todo acesso passa por `try/catch`, como o tema (`lib/tema`): com o
 * armazenamento bloqueado, `localStorage` LEVANTA em vez de devolver `null`, e
 * um rascunho não pode derrubar o formulário.
 */
const PREFIXO = 'ct-frotas:rascunho:';

export interface RascunhoGuardado<T> {
  readonly valor: T;
  /** ISO do último salvamento, para a tela dizer de quando é. */
  readonly salvoEm: string;
}

export function lerRascunho(chave: string): RascunhoGuardado<unknown> | null {
  try {
    const texto = window.localStorage.getItem(PREFIXO + chave);
    if (!texto) return null;
    const lido: unknown = JSON.parse(texto);
    if (typeof lido !== 'object' || lido === null || !('valor' in lido) || !('salvoEm' in lido)) return null;
    const { valor, salvoEm } = lido as { valor: unknown; salvoEm: unknown };
    return typeof salvoEm === 'string' ? { valor, salvoEm } : null;
  } catch {
    return null;
  }
}

export function guardarRascunho(chave: string, valor: unknown): void {
  try {
    window.localStorage.setItem(PREFIXO + chave, JSON.stringify({ valor, salvoEm: new Date().toISOString() }));
  } catch {
    // Armazenamento bloqueado: o formulário continua, só sem rascunho.
  }
}

export function apagarRascunho(chave: string): void {
  try {
    window.localStorage.removeItem(PREFIXO + chave);
  } catch {
    // Idem.
  }
}
